import Axios from "axios";
import PageVariables from "./PageVariables";

Axios.defaults.baseURL = `https://${PageVariables.getApiHost()}`;
Axios.defaults.withCredentials = true;
Axios.defaults.withXSRFToken = true;

export default Axios;
